import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  deletePlantUnit,
  listPlantUnits,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/** 電源ユニットの削除 mutation (楽観ロック)。成功したら一覧を最新化する。 */
export function useDeletePlantUnit(): InvalidatingMutationResultFor<
  typeof deletePlantUnit
> {
  return useInvalidatingMutation(deletePlantUnit, [
    createConnectQueryKey({
      schema: listPlantUnits,
      cardinality: 'finite',
    }),
  ])
}
